<template>
    <div>
        <div>
            <span class="search-preference__title">
                <slot name="label">
                    {{ label }}
                </slot>
            </span>
        </div>
        <div class="search-preference__slider-row">
            <div class="search-preference__slider bio-slider">
                <ElSlider
                    v-model="innerValue"
                    :min="0"
                    :max="100"
                    :show-tooltip="false"
                    range
                    @change="onValueChange"
                />
            </div>
            <div class="search-preference__coverage">
                <div class="base-input base-input-group">
                    <input
                        :value="innerValue[0]"
                        type="text"
                        class="base-input__inner"
                        @keypress="isNumber($event)"
                        @blur="onStartChange"
                    >
                    <span class="separator" />
                    <input
                        :value="innerValue[1]"
                        type="text"
                        class="base-input__inner"
                        @keypress="isNumber($event)"
                        @blur="onEndChange"
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import slider from 'element-ui/lib/slider';
import toNumber from 'lodash/toNumber';
import isNaN from 'lodash/isNaN';

export default {
    name: 'SliderRow',
    components: {
        ElSlider: slider,
    },
    props: {
        value: {
            type: Array,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            innerValue: this.value.slice(0),
        };
    },
    watch: {
        value(val) {
            if (val[0] === this.innerValue[0] && val === this.innerValue[1]) {
                return;
            }
            this.innerValue = this.value.slice(0);
        },
    },
    methods: {
        isNumber(ev) {
            const charCode = ev.keyCode;
            // char code 48 对应 0， char code 57 对应 9， > 31 表示可显示字符
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                ev.preventDefault();
            }
            return true;
        },
        onStartChange(e) {
            let value = toNumber(e.target.value);
            if (isNaN(value) || value > this.innerValue[1] || value < 0) {
                [value] = this.innerValue;
            }
            this.innerValue = [toNumber(value), this.innerValue[1]];
            this.onValueChange();
        },
        onEndChange(e) {
            let value = toNumber(e.target.value);
            if (isNaN(value) || value < this.innerValue[0] || value > 100) {
                [value] = this.innerValue;
            }
            this.innerValue = [this.innerValue[0], value];
            this.onValueChange();
        },
        onValueChange() {
            this.$emit('update:value', this.innerValue);
        },
    },
};
</script>
